import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";

import { docTypeSerializer } from "./anyDoc";

const indexerDtoSerializer = Serializers.object({
  docType: docTypeSerializer,
  indexVersionName: Serializers.string,
  indexAlias: Serializers.string,
  // mappings: Serializers.identity(),
  version: Serializers.string,
});

export type IndexerDto = SerializerValue<typeof indexerDtoSerializer>;

export const indexModuleActions = {
  indexersQuery: HttpAction({
    path: "/indexers",
    valueSerializer: indexerDtoSerializer.array(),
    requiresAuth: true,
  }),
  refreshIndexDocs: HttpAction({
    path: "/refreshDocs",
    method: "post",
    requiresAuth: true,
    qsSerializer: Serializers.object({
      module: docTypeSerializer,
    }),
  }),
};
